import { Component } from '@angular/core';
import { OAuthService, OAuthStorage } from 'angular-oauth2-oidc';

@Component({
    selector: 'app-log-out',
    templateUrl: './log-out.component.html',
    styleUrl: './log-out.component.css',
    standalone: false
})
export class LogOutComponent {
  public constructor(
    private oAuthService: OAuthService,private oAuth: OAuthStorage) { 
      const urlParams = this.getHashParams();
      const deviceHost = urlParams.get('deviceHost')+"&&exponent="+urlParams.get('exponent')+"&&modulus="+urlParams.get('modulus');
      this.oAuthService.logOut(false,deviceHost);
    }
     getHashParams() {
      this.oAuth.removeItem("Access_Token");
      this.oAuth.removeItem("Id_Token");
      sessionStorage.setItem('logOut', '');
      const hash = window.location.hash; // Get the hash part of the URL
      const paramsString = hash.split('?')[1]; // Get the part after '?'
      return new URLSearchParams(paramsString); // Create URLSearchParams object
      
  }
}
